import React from "react";
import styled from "styled-components";
import IconButton from "../../common/Button";
import { RightNavigationIcon, LeftNavigationIcon } from "../../common/Icons";

const NavigationButtons = ({
  activeSection,
  totalSections,
  handleContinue,
  handleBack,
  handleFinish,
}) => {
  const isFirstSection = activeSection === 0;
  const isLastSection = activeSection === totalSections - 1;

  return (
    <ButtonWrapper>
      {!isFirstSection && (
        <LeftButtonWrapper>
          <NavButton
            className="back-btn"
            variant="secondary"
            state="idle"
            width={"200px"}
            icon={<LeftNavigationIcon color="#004F96" />}
            iconPosition="left"
            type="button" // Type is "button" because it is not related to form submission
            aria-label="Back"
            onClick={handleBack}
          >
            <Label>Back</Label>
          </NavButton>
        </LeftButtonWrapper>
      )}
      <RightButtonWrapper>
        <NavButton
          className={isLastSection ? "save-btn" : "next-btn"}
          variant="primary"
          state="idle"
          width={"200px"}
          icon={!isLastSection && <RightNavigationIcon color="#FFF" />}
          iconPosition="right"
          type="submit" // Type is "submit" to trigger validation on form submission
          aria-label={isLastSection ? "Save care plan" : "Continue"}
          onClick={(e) => {
            // Let the form validation decide if the form is valid
            e.preventDefault(); // Prevent default behavior for custom functionality
            const form = e.target.closest("form");
            if (form && form.checkValidity()) {
              isLastSection ? handleFinish() : handleContinue();
            } else {
              form.reportValidity(); // Display validation messages if the form is invalid
            }
          }}
        >
          <Label>{isLastSection ? "Save care plan" : "Continue"}</Label>
        </NavButton>
      </RightButtonWrapper>
    </ButtonWrapper>
  );
};

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  padding: 24px;
  border-top: 1px dashed #e9ecef;
`;

const LeftButtonWrapper = styled.div`
  flex: 0 0 auto;
`;

const RightButtonWrapper = styled.div`
  flex: 0 0 auto;
  margin-left: auto; /* Pushes the right button to the end */
`;

const Label = styled.span`
  font-size: 16px;
  font-weight: 500;
`;

/* base NavButton: same as your IconButton but styled */
const NavButton = styled(IconButton)`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 200px;

  @media (max-width: 600px) {
    &.next-btn,
    &.back-btn {
      width: 40px;
      justify-content: center;
    }
    &.next-btn ${Label}, &.back-btn ${Label} {
      display: none;
    }
    /* full-width save on last section */
    &.save-btn {
      width: 100%;
      justify-content: center;
    }
    &.save-btn ${Label} {
      display: inline;
    }
  }
`;

export default NavigationButtons;
